<template>
  <div class="machines-hub">
    <!-- ============ 复用的既有弹窗（统一挂载在中心根节点） ============ -->
    <edit-user-machine
      :dialogUserMachine="dialogUserMachine"
      :machineGroup="machineGroup"
      :yesNo="yesNo"
      :deviceMode="modeList"
      :userEquipment="editEquipment"
      v-on:cancel="editMachineCancel"
    ></edit-user-machine>
    <open-door-line
      :show="showOpenDoorLine"
      :userEquipment="openDoorMachine"
      @close="handlerCloseOpenDoorLine"
      @refresh="refreshList"
    ></open-door-line>
    <advert-config-dialog
      :visible="dialogAdvertConfig"
      mode="device"
      :equipment-no="advertConfigMachine.equipmentNo"
      :target-name="advertConfigMachine.equipmentName"
      @close="handleAdvertConfigClose"
    ></advert-config-dialog>
    <advert-config-dialog
      :visible="dialogAdvertConfigGroup"
      mode="group"
      :team-id="currentAdvertGroup.id"
      :target-name="currentAdvertGroup.name"
      @close="handleAdvertConfigGroupClose"
    ></advert-config-dialog>
    <refund-dialog :visible="refundVisible" :order="refundOrder" @close="refundVisible = false" @refresh="handleMachineRefundRefresh"></refund-dialog>
    <add-user-machine-group
      :userMachineGroup="userMachineGroup"
      :dialogUserMachineGroup="dialogUserMachineGroup"
      v-on:cancel="groupDialogCancel"
    ></add-user-machine-group>
    <move-user-machine-group
      :teamId="moveTeamId"
      :dialogMoveUserMachineGroup="dialogMoveUserMachineGroup"
      v-on:moveUserMachineGroupCancel="moveUserMachineGroupCancel"
    ></move-user-machine-group>
    <add-user-machine-labels
      :userMachineGroup="userMachineLabel"
      :dialogUserMachineGroup="dialogUserMachineLabel"
      v-on:cancel="labelDialogCancel"
    ></add-user-machine-labels>
    <add-user-group-transfer
      :userGroupTransfer="userGroupTransfer"
      :dialogUserGroupTransfer="dialogUserGroupTransfer"
      v-on:cancel="transferDialogCancel"
    ></add-user-group-transfer>

    <!-- 开门二维码弹窗 -->
    <el-dialog
      :title="$t('machinesHub.showQr')"
      :visible.sync="showOpenDoorQrCode"
      width="30%"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div style="display: flex; justify-content: center; align-items: center">
        <el-image
          style="width: 300px; height: 300px"
          fit="contain"
          v-loading="showOpenDoorQrLoading"
          element-loading-background="rgba(0, 0, 0, 0.3)"
          :src="openDoorQrCode"
        ></el-image>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showOpenDoorQrCode = false">{{ $t("common.close") }}</el-button>
      </div>
    </el-dialog>

    <!-- 远程控制隐藏表单（自 MachineMaps 移植） -->
    <form :action="control.url" method="post" target="_blank" style="display: none">
      <input name="c" :value="control.remoteId" />
      <input name="pass" :value="control.remoteCode" />
      <input name="dn" :value="'Reyeah'" />
      <input name="lang" :value="'0'" />
      <button ref="btnForm" type="submit">{{ $t("user.MachineMaps.588934-1") }}</button>
    </form>

    <!-- ============ 地址弹窗（自 MachineUser 移植） ============ -->
    <el-dialog
      class="location-dialog"
      :modal-append-to-body="true"
      :append-to-body="true"
      :visible.sync="addressDialogVisible"
      width="750px"
    >
      <span slot="title" class="dialog-title-left">Location Details</span>
      <div class="popup-form">
        <el-form :model="addressForm">
          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Address</el-col>
            <el-col :span="17" class="popup-field">
              <el-autocomplete
                v-model="addressForm.location"
                :fetch-suggestions="querySearch"
                placeholder="Enter"
                style="width: 100%"
                popper-class="address-suggestion-dropdown"
                @select="handleAddressSelect"
              >
                <template slot="prefix"><i class="el-icon-search ip-icon" style="margin-right: 4px"></i></template>
                <template slot="suffix">
                  <i
                    v-if="addressForm.location"
                    class="el-icon-close ip-icon"
                    style="cursor: pointer"
                    @click="clearAddress"
                  ></i>
                </template>
                <template slot-scope="{ item }">
                  <div class="address-suggestion-item">
                    <span class="location-icon-bg"><i class="el-icon-location"></i></span>
                    <div class="suggestion-text">
                      <div class="suggestion-title">{{ item.name }}</div>
                      <div class="suggestion-address">
                        <span v-if="item.county" style="color: var(--vtm-mint-ink); font-weight: 500; margin-right: 6px">{{
                          item.county
                        }}</span>
                        {{ item.address }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-autocomplete>
            </el-col>
          </el-row>
          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Contact Name</el-col>
            <el-col :span="17" class="popup-field">
              <el-input v-model="addressForm.Contact" placeholder="Enter contact name" style="width: 100%"></el-input>
            </el-col>
          </el-row>
          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Phone Number</el-col>
            <el-col :span="17" class="popup-field">
              <el-input v-model="addressForm.PhoneNumber" placeholder="Enter phone number" style="width: 100%"></el-input>
            </el-col>
          </el-row>
          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Email</el-col>
            <el-col :span="17" class="popup-field">
              <el-input v-model="addressForm.email" placeholder="Enter email" style="width: 100%"></el-input>
            </el-col>
          </el-row>
          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Notes</el-col>
            <el-col :span="17" class="popup-field">
              <el-input type="textarea" v-model="addressForm.Notes" placeholder="Enter notes" :rows="3" style="width: 100%"></el-input>
            </el-col>
          </el-row>
          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Install Date</el-col>
            <el-col :span="17" class="popup-field">
              <el-date-picker
                v-model="addressForm.Installed"
                type="date"
                placeholder="Select install date"
                style="width: 100%"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer-left">
        <el-button type="primary" @click="saveAddress">Save</el-button>
        <el-button @click="addressDialogVisible = false">Cancel</el-button>
      </div>
    </el-dialog>

    <!-- ============ 页头 ============ -->
    <div class="vtm-page-head">
      <div>
        <h1 class="vtm-page-head__title">{{ $t("machinesHub.title") }}</h1>
        <div class="vtm-page-head__sub">{{ $t("machinesHub.subtitle") }}</div>
      </div>
    </div>

    <!-- ============ KPI 概览 ============ -->
    <section class="hub-kpis">
      <div class="hub-kpi-click" @click="filterTotal">
        <stat-card icon="el-icon-cpu" :label="$t('machinesHub.kpiTotal')" :value="kpi.equipmentTotalNum || 0"></stat-card>
      </div>
      <div class="hub-kpi-click" @click="filterOnline">
        <stat-card
          tone="ok"
          icon="el-icon-success"
          :label="$t('machinesHub.kpiOnline')"
          :value="kpi.equipmentMqYesNum || 0"
        ></stat-card>
      </div>
      <div class="hub-kpi-click" @click="filterOffline">
        <stat-card
          tone="crit"
          icon="el-icon-warning-outline"
          :label="$t('machinesHub.kpiOffline')"
          :value="kpi.equipmentMqNoNum || 0"
        ></stat-card>
      </div>
      <div v-if="faultCount !== null" class="hub-kpi-click" @click="filterFaults">
        <stat-card
          tone="warn"
          icon="el-icon-bell"
          :label="$t('machinesHub.kpiFaults')"
          :value="faultCount"
        ></stat-card>
      </div>
    </section>

    <!-- ============ 模式切换 List | Map | Groups（非列表模式独立呈现；列表模式并入工具条同一行）============ -->
    <div v-show="mode !== 'list'" class="hub-seg-row">
      <el-radio-group v-model="mode" size="small" class="hub-seg" @change="handleModeChange">
        <el-radio-button label="list"><i class="el-icon-s-grid"></i> {{ $t("machinesHub.viewList") }}</el-radio-button>
        <el-radio-button label="map"><i class="el-icon-map-location"></i> {{ $t("machinesHub.viewMap") }}</el-radio-button>
        <el-radio-button label="groups"><i class="el-icon-collection"></i> {{ $t("machinesHub.viewGroups") }}</el-radio-button>
      </el-radio-group>
    </div>

    <!-- ============ LIST ============ -->
    <list-page
      v-show="mode === 'list'"
      :loading="loading"
      :error="loadError"
      :empty="!displayedMachines.length"
      :empty-text="$t('machinesHub.noMachines')"
      :total="page.totalSize || 0"
      :page-index="page.pageIndex"
      :page-size="page.pageSize"
      @page-change="currentChange"
      @size-change="sizeChange"
      @retry="currentChange(page.pageIndex)"
    >
      <!-- 视图切换/导出与筛选条挂在 list-page 自己的常驻插槽上，
           而不是 vtm-table 的 toolbar 插槽——vtm-table 在卡片视图下会被 v-if 卸载，
           挂在它里面会导致卡片视图下连切回列表视图的按钮都消失 -->
      <template #head-actions>
        <el-radio-group v-model="mode" size="small" class="hub-seg hub-seg--inline" @change="handleModeChange">
          <el-radio-button label="list"><i class="el-icon-s-grid"></i> {{ $t("machinesHub.viewList") }}</el-radio-button>
          <el-radio-button label="map"><i class="el-icon-map-location"></i> {{ $t("machinesHub.viewMap") }}</el-radio-button>
          <el-radio-button label="groups"><i class="el-icon-collection"></i> {{ $t("machinesHub.viewGroups") }}</el-radio-button>
        </el-radio-group>
        <el-button
          size="small"
          v-hasPerm="['user:machine:export']"
          icon="el-icon-receiving"
          @click="exportUserMachine"
          >{{ $t("common.export") }}</el-button
        >
        <div class="hub-viewtoggle">
          <button type="button" :class="{ 'is-active': viewMode === 'card' }" :title="$t('machinesHub.cardView')" @click="viewMode = 'card'">
            <i class="el-icon-menu"></i>
          </button>
          <button type="button" :class="{ 'is-active': viewMode === 'list' }" :title="$t('machinesHub.listView')" @click="viewMode = 'list'">
            <i class="el-icon-s-unfold"></i>
          </button>
        </div>
      </template>
      <vtm-table
        v-if="viewMode === 'list'"
        table-id="machines-mine"
        ref="machineTable"
        :columns="userMachineColumns"
        :data="displayedMachines"
        :loading="loading"
        :search-fields="['equipmentNo', 'equipmentName', 'locale']"
        :search-placeholder="$t('machinesHub.searchPlaceholder')"
        :empty-text="$t('machinesHub.noMachines')"
        row-key="id"
        :border="true"
        @sort-change="sortChange"
        @row-click="onRowClick"
      >
        <template #toolbar-filters>
          <filter-bar :value="search" :fields="machineFilterFields" @search="onSubmit" @reset="resetSearch"></filter-bar>
        </template>
        <template #prepend>
        </template>
        <template #equipmentNo="scope">
          <div class="hub-cell-machine">
            <span class="hub-cell-machine__name">{{ scope.row.equipmentName || scope.row.equipmentNo || "-" }}</span>
            <span class="hub-cell-machine__no">{{ scope.row.equipmentNo }}</span>
          </div>
        </template>
        <template #locale="scope">
          <span v-if="scope.row.locale">{{ cleanAddress(scope.row.locale) }}</span>
          <el-link v-else type="danger" @click.stop="openAddressDialog(scope.row)">{{ $t("machinesHub.addAddress") }}</el-link>
        </template>
        <template #teamName="scope">
          <span>{{ (scope.row.userEquipmentTeam && scope.row.userEquipmentTeam.name) || $t("machinesHub.noGroup") }}</span>
        </template>
        <template #mqState="scope">
          <span :class="['vtm-pill', onlinePill(scope.row).cls]">{{ onlinePill(scope.row).label }}</span>
        </template>
        <template #enableStatus="scope">
          <span>{{ enableStatusLabel(scope.row) }}</span>
        </template>
        <template #products="scope">
          <span v-if="invMap[scope.row.id]" class="vtm-num">{{ invMap[scope.row.id].products }}</span>
          <span v-else class="hub-inv-pending">{{ scope.row.id ? "…" : "-" }}</span>
        </template>
        <template #inventory="scope">
          <span v-if="invMap[scope.row.id]" class="vtm-num">{{ invMap[scope.row.id].inventory }}</span>
          <span v-else class="hub-inv-pending">{{ scope.row.id ? "…" : "-" }}</span>
        </template>
        <template #lastTx="scope">
          <div v-if="txMap[scope.row.id]" class="hub-cell-lasttx">
            <template v-if="txMap[scope.row.id].lastTime">
              <span class="hub-cell-lasttx__time">{{ txMap[scope.row.id].lastTime }}</span>
              <span class="hub-cell-lasttx__ago">{{ relTime(txMap[scope.row.id].lastTime) }}</span>
            </template>
            <span v-else class="hub-inv-pending">{{ $t("machinesHub.noSalesYet") }}</span>
          </div>
          <span v-else class="hub-inv-pending">{{ scope.row.equipmentNo ? "…" : "-" }}</span>
        </template>
        <template #sales7d="scope">
          <span v-if="txMap[scope.row.id]" class="vtm-num">{{ money(txMap[scope.row.id].sales7d) }}</span>
          <span v-else class="hub-inv-pending">{{ scope.row.equipmentNo ? "…" : "-" }}</span>
        </template>
        <template #append>
          <el-table-column fixed="right" :label="$t('common.operate')" width="175" :align="'center'">
            <template slot-scope="scope">
              <el-button
                size="mini"
                v-hasPerm="['machine:line:product:update']"
                :disabled="!scope.row.id"
                icon="el-icon-s-goods"
                @click.stop="openDoorLineProduct(scope.row)"
                >{{ $t("planogram.manageAisles") }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </vtm-table>

      <!-- 卡片视图 -->
      <div v-if="viewMode === 'card'" class="hub-grid">
        <article v-for="row in displayedMachines" :key="row.id" class="hub-mcard" @click="openMachineDrawer(row)">
          <header class="hub-mcard__head">
            <div class="hub-mcard__title">
              <span class="hub-mcard__name" :title="row.equipmentName">{{ row.equipmentName || row.equipmentNo || "-" }}</span>
              <span class="hub-mcard__no">{{ row.equipmentNo }}</span>
            </div>
            <span :class="['vtm-pill', onlinePill(row).cls]">{{ onlinePill(row).label }}</span>
          </header>
          <div class="hub-mcard__body">
            <div class="hub-mcard__row"><i class="el-icon-location-outline"></i> {{ row.locale ? cleanAddress(row.locale) : "-" }}</div>
            <div class="hub-mcard__row">
              <i class="el-icon-collection"></i>
              {{ (row.userEquipmentTeam && row.userEquipmentTeam.name) || $t("machinesHub.noGroup") }}
            </div>
            <div class="hub-mcard__inv">
              <span class="hub-mcard__inv-item">
                <span class="hub-mcard__inv-val vtm-num">{{ invMap[row.id] ? invMap[row.id].products : (row.id ? "…" : "-") }}</span>
                <span class="hub-mcard__inv-label">{{ $t("machinesHub.colProducts") }}</span>
              </span>
              <span class="hub-mcard__inv-item">
                <span class="hub-mcard__inv-val vtm-num">{{ invMap[row.id] ? invMap[row.id].inventory : (row.id ? "…" : "-") }}</span>
                <span class="hub-mcard__inv-label">{{ $t("machinesHub.colInventory") }}</span>
              </span>
            </div>
            <div class="hub-mcard__foot">
              <el-button
                size="mini"
                v-hasPerm="['machine:line:product:update']"
                icon="el-icon-s-goods"
                @click.stop="openDoorLineProduct(row)"
                >{{ $t("planogram.manageAisles") }}</el-button
              >
            </div>
          </div>
        </article>
      </div>
    </list-page>

    <!-- ============ MAP ============ -->
    <div v-show="mode === 'map'" class="hub-map-wrap" v-loading="mapLoading">
      <div id="hubMapBox" class="hub-map-box">{{ $t("user.MachineMaps.588934-0") }}</div>
    </div>

    <!-- ============ GROUPS ============ -->
    <div v-show="mode === 'groups'" class="hub-groups">
      <el-tabs v-model="groupsTab" @tab-click="handleGroupsTab">
        <!-- 分组 -->
        <el-tab-pane :label="$t('machinesHub.groupsTab')" name="groups">
          <div class="hub-groups__toolbar">
            <el-button
              type="primary"
              v-hasPerm="['user:machine:group:insert']"
              size="small"
              icon="el-icon-plus"
              @click="addUserMachineGroup"
              >{{ $t("common.add") }}</el-button
            >
          </div>
          <el-table :data="groupList" v-loading="groupLoading" size="small" :border="true" max-height="560">
            <el-table-column prop="nickName" :label="$t('userMachineGroup.nickName')" align="center"></el-table-column>
            <el-table-column prop="name" :label="$t('userMachineGroup.name')" align="center"></el-table-column>
            <el-table-column :label="$t('common.operate')" width="360" align="center">
              <template slot-scope="scope">
                <el-button size="mini" v-hasPerm="['user:machine:group:insert']" @click="editMachineGroup(scope.row)">{{
                  $t("common.edit")
                }}</el-button>
                <el-button size="mini" v-hasPerm="['user:machine:group:move']" type="warning" @click="transferMachine(scope.row)">{{
                  $t("userMachineGroup.transfer")
                }}</el-button>
                <el-button size="mini" type="primary" icon="el-icon-picture-outline-round" @click="openAdvertConfigGroup(scope.row)">{{
                  $t("advertGroup.advertConfig")
                }}</el-button>
                <el-button size="mini" type="danger" icon="el-icon-delete" @click="delMachineGroup(scope.row)">{{
                  $t("common.delete")
                }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            small
            layout="prev, pager, next"
            :current-page="groupPage.pageIndex"
            :total="groupPage.totalSize"
            :page-size="groupPage.pageSize"
            @current-change="loadGroups"
          ></el-pagination>
        </el-tab-pane>

        <!-- 标签 -->
        <el-tab-pane :label="$t('machinesHub.labelsTab')" name="labels">
          <div class="hub-groups__toolbar">
            <el-button
              type="primary"
              v-hasPerm="['user:machine:group:insert']"
              size="small"
              icon="el-icon-plus"
              @click="addUserMachineLabel"
              >{{ $t("common.add") }}</el-button
            >
          </div>
          <el-table :data="labelList" v-loading="labelLoading" size="small" :border="true" max-height="560">
            <el-table-column prop="name" :label="$t('common.labelName')" align="center"></el-table-column>
            <el-table-column :label="$t('common.operate')" width="220" align="center">
              <template slot-scope="scope">
                <el-button size="mini" v-hasPerm="['user:machine:group:insert']" @click="editMachineLabel(scope.row)">{{
                  $t("common.edit")
                }}</el-button>
                <el-button size="mini" type="danger" icon="el-icon-delete" @click="delMachineLabel(scope.row)">{{
                  $t("common.delete")
                }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            small
            layout="prev, pager, next"
            :current-page="labelPage.pageIndex"
            :total="labelPage.totalSize"
            :page-size="labelPage.pageSize"
            @current-change="loadLabels"
          ></el-pagination>
        </el-tab-pane>

        <!-- 转移分组 -->
        <el-tab-pane :label="$t('machinesHub.transferTab')" name="transfer">
          <div class="hub-groups__toolbar">
            <el-button
              type="primary"
              v-hasPerm="['user:machine:group:insert']"
              size="small"
              icon="el-icon-plus"
              @click="addUserGroupTransfer"
              >{{ $t("common.add") }}</el-button
            >
          </div>
          <el-table :data="transferList" v-loading="transferLoading" size="small" :border="true" max-height="560">
            <el-table-column prop="nickName" :label="$t('userMachineGroup.nickName')" align="center"></el-table-column>
            <el-table-column prop="name" :label="$t('userMachineGroup.name')" align="center"></el-table-column>
            <el-table-column :label="$t('common.operate')" width="220" align="center">
              <template slot-scope="scope">
                <el-button size="mini" @click="editGroupTransfer(scope.row)">{{ $t("common.edit") }}</el-button>
                <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelGroupTransfer(scope.row)">{{
                  $t("common.delete")
                }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            small
            layout="prev, pager, next"
            :current-page="transferPage.pageIndex"
            :total="transferPage.totalSize"
            :page-size="transferPage.pageSize"
            @current-change="loadTransfers"
          ></el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- ============ 设备详情抽屉 ============ -->
    <el-drawer :visible.sync="drawerVisible" :with-header="false" size="600px" :append-to-body="true" @closed="drawerMachine = {}">
      <div class="hub-detail" v-if="drawerMachine">
        <div class="hub-detail__topbar">
          <div class="hub-detail__title">
            <i class="el-icon-cpu"></i>
            <div>
              <div class="hub-detail__name">{{ drawerMachine.equipmentName || drawerMachine.equipmentNo || "-" }}</div>
              <div class="hub-detail__no">{{ drawerMachine.equipmentNo }}</div>
            </div>
          </div>
          <div class="hub-detail__pills">
            <span :class="['vtm-pill', onlinePill(drawerMachine).cls]">{{ onlinePill(drawerMachine).label }}</span>
            <span :class="['vtm-pill', Number(drawerMachine.enableStatus) === 1 ? 'vtm-pill--ok' : 'vtm-pill--crit']">
              {{ Number(drawerMachine.enableStatus) === 1 ? $t("machinesHub.enabled") : $t("machinesHub.disabled") }}
            </span>
            <el-button type="text" icon="el-icon-close" @click="drawerVisible = false"></el-button>
          </div>
        </div>

        <div class="hub-detail__scroll">
          <el-tabs v-model="drawerTab" @tab-click="onDrawerTab">
            <!-- 概览 -->
            <el-tab-pane :label="$t('machinesHub.tabOverview')" name="overview">
              <!-- 设备信息：直接内联编辑（原「编辑设备」弹窗字段），自动保存 -->
              <div class="hub-detail__kv">
                <div class="hub-detail__kv-item">
                  <span class="hub-detail__kv-label">{{ $t("editUserMachine.name") }}</span>
                  <el-input
                    v-model="drawerMachine.equipmentName"
                    size="small"
                    :class="{ 'hub-detail__input--warn': nameIsDefault }"
                    :placeholder="$t('editUserMachine.pName')"
                    @change="queueMachineInfoSave"
                  ></el-input>
                  <!-- 出厂默认机名提醒：提示重命名 -->
                  <div v-if="nameIsDefault" class="hub-detail__field-warn">
                    <i class="el-icon-warning-outline"></i> {{ $t("machinesHub.defaultNameWarn") }}
                  </div>
                </div>
                <div class="hub-detail__kv-item">
                  <span class="hub-detail__kv-label">{{ $t("machinesHub.colGroup") }}</span>
                  <el-select
                    v-model="drawerMachine.teamId"
                    size="small"
                    filterable
                    clearable
                    style="width: 100%"
                    :placeholder="$t('machinesHub.noGroup')"
                    @change="queueMachineInfoSave"
                  >
                    <el-option v-for="item in machineGroup" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </div>
                <div class="hub-detail__kv-item hub-detail__kv-item--full">
                  <span class="hub-detail__kv-label">{{ $t("machinesHub.colAddress") }}</span>
                  <span class="hub-detail__kv-value">
                    <template v-if="drawerMachine.locale">{{ cleanAddress(drawerMachine.locale) }}</template>
                    <el-link v-else type="danger" @click="openAddressDialog(drawerMachine)">{{ $t("machinesHub.addAddress") }}</el-link>
                    <el-button
                      v-if="drawerMachine.locale"
                      type="text"
                      icon="el-icon-edit"
                      style="margin-left: 6px"
                      @click="openAddressDialog(drawerMachine)"
                    ></el-button>
                  </span>
                </div>
                <div class="hub-detail__kv-item">
                  <span class="hub-detail__kv-label">{{ $t("machinesHub.servicePhone") }}</span>
                  <el-input
                    v-model="drawerMachine.servicePhone"
                    size="small"
                    :placeholder="$t('editUserMachine.pServicePhone')"
                    @change="queueMachineInfoSave"
                  ></el-input>
                </div>
                <div class="hub-detail__kv-item">
                  <span class="hub-detail__kv-label">{{ $t("editUserMachine.enableStatus") }}</span>
                  <span class="hub-detail__kv-value">
                    <el-switch
                      :value="Number(drawerMachine.enableStatus) === 1"
                      @change="v => { drawerMachine.enableStatus = v ? 1 : 0; queueMachineInfoSave(); }"
                    ></el-switch>
                  </span>
                </div>
                <div class="hub-detail__kv-item hub-detail__kv-item--full">
                  <span class="hub-detail__kv-label">{{ $t("editUserMachine.notes") }}</span>
                  <el-input
                    v-model="drawerMachine.notes"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    size="small"
                    @change="queueMachineInfoSave"
                  ></el-input>
                </div>
                <div class="hub-detail__kv-item hub-detail__kv-item--full hub-detail__kv-savehint">
                  <span v-if="infoSaveState === 'saving'" class="is-saving"><i class="el-icon-loading"></i> {{ $t("machinesHub.saving") }}</span>
                  <span v-else-if="infoSaveState === 'saved'" class="is-saved"><i class="el-icon-check"></i> {{ $t("machinesHub.saved") }}</span>
                  <span v-else class="is-hint">{{ $t("machinesHub.autoSaveHint") }}</span>
                </div>
              </div>
              <div class="hub-detail__actions-row">
                <el-button size="small" type="primary" icon="el-icon-unlock" @click="handleUnlocking(drawerMachine)">{{
                  $t("machinesHub.unlock")
                }}</el-button>
                <el-button size="small" icon="el-icon-picture-outline" @click="showOpenDoorQr(drawerMachine)">{{
                  $t("machinesHub.showQr")
                }}</el-button>
                <el-button
                  size="small"
                  v-hasPerm="['machine:line:product:update']"
                  :disabled="!drawerMachine.id"
                  icon="el-icon-s-goods"
                  @click="openDoorLineProduct(drawerMachine)"
                  >{{ $t("planogram.manageAisles") }}</el-button
                >
                <el-button size="small" icon="el-icon-picture-outline-round" @click="openAdvertConfig(drawerMachine)">{{
                  $t("machinesHub.adConfig")
                }}</el-button>
              </div>
            </el-tab-pane>

            <!-- 配置：设备完整配置项，独立页签 -->
            <el-tab-pane :label="$t('machinesHub.tabConfig')" name="config">
              <div v-if="drawerMachine.id" class="hub-settings">
                <config-user-machine
                  inline
                  :userEquipment="ConfigSubmit"
                  :yesNo="yesNo"
                  :deviceMode="modeList"
                  :ageDevice="ageDevice"
                  :feelLock="feelLock"
                  :ageType="ageType"
                  :priorityMode="priorityMode"
                  :IdcardCountry="IdcardCountry"
                  :biaoshi="false"
                  v-on:cancel="configCancel"
                ></config-user-machine>
              </div>
            </el-tab-pane>

            <!-- 支付：仅具备权限时可见 -->
            <el-tab-pane :label="$t('machinesHub.tabPayment')" name="payment" v-hasPerm="['user:machine:payment']">
              <div v-if="drawerMachine.id" class="hub-settings">
                <payment inline :payment="payment" :yesNo="yesNo" :shuaKaQi="shuaKaQi" v-on:cancelPayment="cancelPayment"></payment>
              </div>
            </el-tab-pane>

            <!-- 设备控制 -->
            <!-- 交易：该设备近期订单 + 退款 -->
            <el-tab-pane :label="$t('machinesHub.tabTransactions')" name="transactions">
              <div v-loading="machineOrdersLoading" class="hub-txns">
                <div v-if="machineOrders.length" class="hub-txns__list">
                  <div v-for="o in machineOrders" :key="o.id" class="hub-txn">
                    <div class="hub-txn__main">
                      <div class="hub-txn__top">
                        <strong class="vtm-num">{{ money(o.payablePrice) }}</strong>
                        <span :class="['vtm-pill', orderPillClass(o)]">{{ payStateText(o) }}</span>
                        <span v-if="Number(o.refundPrice) > 0" class="vtm-pill vtm-pill--crit">{{ $t("refund.refunded") }}</span>
                      </div>
                      <div class="hub-txn__sub">
                        <span>{{ payLabel(o) }}<template v-if="cardLabelOf(o)"> · {{ cardLabelOf(o) }}</template></span>
                        <span class="hub-txn__time">{{ o.createTime }}</span>
                      </div>
                      <div class="hub-txn__no">{{ o.orderNumber }}</div>
                    </div>
                    <el-button
                      v-if="canRefund(o)"
                      size="mini"
                      type="danger"
                      plain
                      icon="el-icon-bank-card"
                      @click="openRefund(o)"
                      >{{ $t("refund.issue") }}</el-button
                    >
                  </div>
                </div>
                <el-empty v-else-if="!machineOrdersLoading" :description="$t('machinesHub.noTxns')" :image-size="56"></el-empty>
                <div v-if="machineOrders.length" class="hub-txns__foot">
                  <el-button type="text" size="small" @click="goMachineTxns">{{ $t("machinesHub.viewAllTxns") }}</el-button>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane :label="$t('machinesHub.tabControl')" name="control">
              <el-alert :title="$t('machinesHub.controlHint')" type="warning" :closable="false" show-icon class="hub-detail__ctrlhint" />
              <div class="hub-detail__actions-col">
                <el-dropdown @command="cmd => handlerReStart(drawerMachine.equipmentNo, cmd)">
                  <el-button type="danger" icon="el-icon-refresh-right" style="width: 100%">
                    {{ $t("machinesHub.restart") }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="2">{{ $t("user.MachineMaps.588934-2") }}</el-dropdown-item>
                    <el-dropdown-item command="1">{{ $t("user.MachineMaps.588934-3") }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="cmd => (cmd === 'on' ? handleOpenNetwork(drawerMachine) : handleCloseNetwork(drawerMachine))">
                  <el-button icon="el-icon-connection" style="width: 100%">
                    {{ $t("machinesHub.network") }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="on">{{ $t("machinesHub.networkOn") }}</el-dropdown-item>
                    <el-dropdown-item command="off">{{ $t("machinesHub.networkOff") }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-button icon="el-icon-monitor" @click="handleControl(drawerMachine)">{{ $t("machinesHub.remoteConnect") }}</el-button>
                <el-button icon="el-icon-unlock" @click="handleUnlocking(drawerMachine)">{{ $t("machinesHub.unlock") }}</el-button>
                <el-dropdown @command="type => handleSendLogMQ(drawerMachine.equipmentNo, type)">
                  <el-button style="width: 100%">
                    {{ $t("machinesHub.sendLog") }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="1">{{ $t("common.kernelrz") }}</el-dropdown-item>
                    <el-dropdown-item :command="2">{{ $t("common.dskgj") }}</el-dropdown-item>
                    <el-dropdown-item :command="3">{{ $t("common.azrizhi") }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

      </div>
    </el-drawer>
  </div>
</template>

<script>
  // 设备中心（MachinesHub）：整合原六个经销商设备页面为「列表 | 地图 | 分组」+ 设备详情抽屉。
  // 端点、参数与弹窗全部复用既有实现，不改动后端契约与被复用组件。
  import ListPage from "_c/common/ListPage.vue";
  import VtmTable from "_c/common/VtmTable.vue";
  import FilterBar from "_c/common/FilterBar.vue";
  import StatCard from "_c/common/StatCard.vue";
  import editUserMachine from "_c/machine/user/EditUserMachine";
  import configUserMachine from "_c/machine/user/ConfigUserMachine";
  import openDoorLine from "_c/machine/user/OpenDoorLine";
  import payment from "_c/machine/user/Payment";
  import advertConfigDialog from "_c/adverts/AdvertConfigDialog";
  import refundDialog from "_c/order/RefundDialog";
  import { orderCardLabel } from "@/utils/paymentInfo";
  import addUserMachineGroup from "_c/machine/user/AddUserMachineGroup";
  import moveUserMachineGroup from "_c/machine/user/MoveUserMachineGroup";
  import addUserMachineLabels from "_c/machine/user/AddUserMachineLabels";
  import addUserGroupTransfer from "_c/machine/user/AddUserGroupTransfer";
  import { queryPlaces, loadGoogle } from "@/utils/googlePlaces";
  import { isDefaultMachineName } from "@/utils/machineDefaults";
  import { MarkerClusterer } from "@googlemaps/markerclusterer";

  let mapMarker = null;
  let mapPositions = [];

  const emptyConfigSubmit = () => ({
    config: {
      info: {
        isPAd: null, isTAd: null, isPTag: null, isFaultClose: null, isCoupon: null, isEye: null,
        isPrivacy: null, privacy: "", isSms: null, isFaultLock: null, moneySign: "", isGoodsMode: null
      },
      manager: { isOpen: null, isDebug: null, passWord: "" },
      remote: { isBlue: null, blueType: null, isHaptic: null, hapticType: null },
      model: { type: null, lockPage: null, isPrompt: null, title: "", message: "", confirm: "", cancel: "", passWord: "", time: [] },
      vatRate: { isOpen: null, isCalculating: null, type: null, proportion: null },
      shopping: { isTip: null, tipTitle: "", tipMessage: "", tipConfirm: "", tipCancel: "", isCart: null, cartNum: null },
      age: {
        isAge: null, ageCamera: null, ageQrCode: null, agePriority: null, ageDevice: "", isAgeFace: null, ageCount: null,
        ageSDK: null, faceSimilarity: null, isSecurity: null, isFace: null, time: [], ageRange: null
      },
      elock: { isOpen: null },
      advert: { isCountdown: null, countdown: "" }
    },
    equipmentNo: "",
    id: "",
    verify: [],
    walletPrice: ""
  });

  export default {
    name: "MachinesHub",
    components: {
      ListPage,
      VtmTable,
      FilterBar,
      StatCard,
      editUserMachine,
      configUserMachine,
      openDoorLine,
      payment,
      advertConfigDialog,
      refundDialog,
      addUserMachineGroup,
      moveUserMachineGroup,
      addUserMachineLabels,
      addUserGroupTransfer
    },
    data() {
      return {
        mode: "list",
        viewMode: "list",
        // ---- KPI ----
        kpi: {},
        faultCount: null,
        // ---- 列表 ----
        loading: false,
        loadError: false,
        userMachineList: [],
        onlineFilter: "all", // all | online | offline | fault
        faultEquipmentNos: [], // 报警设备号集合（点击 Faults KPI 时按需加载）
        page: { pageSize: 10, pageIndex: 1, totalSize: 0 },
        search: { equipmentName: "", equipmentNo: "", userName: "", enableStatus: "", teamId: "" },
        uId: localStorage.getItem("uId"),
        pId: localStorage.getItem("pId"),
        // ---- 字典 ----
        yesNo: [],
        ageDevice: [],
        feelLock: [],
        ageType: [],
        priorityMode: [],
        shuaKaQi: [],
        modeList: [],
        IdcardCountry: [],
        machineGroup: [],
        // 库存概览缓存：machineId → { products, inventory }
        invMap: {},
        txMap: {}, // 每台设备：最近交易时间 + 近7天销售额（缓存）
        // ---- 抽屉 ----
        drawerVisible: false,
        drawerTab: "overview",
        // 概览内「设置」折叠面板：默认展开设备设置
        drawerMachine: {},
        infoSaveState: "idle", // idle | saving | saved（设备信息内联自动保存）
        infoSaveTimer: null,
        infoSaveResetTimer: null,
        // 设备交易（近期订单）+ 退款
        machineOrders: [],
        machineOrdersLoading: false,
        payTypeList: [],
        payStateList: [],
        refundVisible: false,
        refundOrder: {},
        // ---- 复用弹窗状态 ----
        dialogUserMachine: false,
        editEquipment: {},
        ConfigSubmit: emptyConfigSubmit(),
        payment: { equipmentNo: "", id: "", payConfig: {} },
        showOpenDoorLine: false,
        openDoorMachine: {},
        dialogAdvertConfig: false,
        advertConfigMachine: { equipmentNo: "", equipmentName: "" },
        // ---- 二维码 ----
        showOpenDoorQrCode: false,
        showOpenDoorQrLoading: false,
        openDoorQrCode: "",
        // ---- 远程控制 ----
        control: { remoteCode: "", remoteId: "", remoteStatus: 0, url: "" },
        nowRemoteInfo: {},
        countError: 0,
        // ---- 地址弹窗 ----
        addressDialogVisible: false,
        selectedMachine: null,
        addressForm: { name: "", location: "", lat: "", lng: "" },
        // ---- 地图 ----
        mapLoading: false,
        mapInited: false,
        longitude: "",
        latitude: "",
        // ---- 分组 ----
        groupsTab: "groups",
        groupList: [],
        groupLoading: false,
        groupPage: { pageSize: 10, pageIndex: 1, totalSize: 0 },
        dialogUserMachineGroup: false,
        userMachineGroup: { id: "", name: "", userEquipmentIds: [], maintenances: [] },
        dialogMoveUserMachineGroup: false,
        moveTeamId: "",
        dialogAdvertConfigGroup: false,
        currentAdvertGroup: { id: "", name: "" },
        // ---- 标签 ----
        labelList: [],
        labelLoading: false,
        labelPage: { pageSize: 10, pageIndex: 1, totalSize: 0 },
        labelSearch: { teamName: "" },
        dialogUserMachineLabel: false,
        userMachineLabel: { id: "", name: "", userEquipmentId: [] },
        // ---- 转移分组 ----
        transferList: [],
        transferLoading: false,
        transferPage: { pageSize: 10, pageIndex: 1, totalSize: 0 },
        transferSearch: { userName: "", name: "" },
        dialogUserGroupTransfer: false,
        userGroupTransfer: { id: "", name: "", userMachineId: [] }
      };
    },
    computed: {
      // 机名仍为出厂默认（Slim Wall 等）→ 提示重命名
      nameIsDefault() {
        return isDefaultMachineName(this.drawerMachine && this.drawerMachine.equipmentName);
      },
      machineFilterFields() {
        return [
          {
            key: "teamId",
            type: "select",
            primary: false,
            placeholder: this.$t("machinesHub.filterGroup"),
            options: (this.machineGroup || []).map(item => ({ label: item.name, value: item.id })),
            width: "160px"
          },
          {
            key: "enableStatus",
            type: "select",
            primary: false,
            placeholder: this.$t("machinesHub.filterStatus"),
            options: (this.yesNo || []).map(item => ({ label: item.label, value: item.value })),
            width: "150px"
          }
        ];
      },
      userMachineColumns() {
        return [
          { prop: "equipmentNo", label: this.$t("machinesHub.colMachine"), width: 180, sortable: "custom", tooltip: false },
          { prop: "locale", label: this.$t("machinesHub.colAddress"), minWidth: 200, sortable: "custom", tooltip: false },
          { prop: "teamName", label: this.$t("machinesHub.colGroup"), width: 150, align: "center", tooltip: false },
          { prop: "mqState", label: this.$t("machinesHub.colStatus"), width: 110, align: "center", sortable: "mqState", tooltip: false },
          { prop: "products", label: this.$t("machinesHub.colProducts"), width: 100, align: "center", tooltip: false },
          { prop: "inventory", label: this.$t("machinesHub.colInventory"), width: 110, align: "center", tooltip: false },
          { prop: "lastTx", label: this.$t("machinesHub.colLastTx"), width: 175, tooltip: false },
          { prop: "sales7d", label: this.$t("machinesHub.colSales7d"), width: 120, align: "center", tooltip: false },
          {
            prop: "enableStatus",
            label: this.$t("machineUser.enableStatus"),
            width: 90,
            align: "center",
            tooltip: false,
            hidden: true
          }
        ];
      },
      displayedMachines() {
        if (this.onlineFilter === "online") {
          return this.userMachineList.filter(m => m.mqState == 1);
        }
        if (this.onlineFilter === "offline") {
          return this.userMachineList.filter(m => m.mqState == 0);
        }
        if (this.onlineFilter === "fault") {
          const nos = new Set(this.faultEquipmentNos);
          return this.userMachineList.filter(m => nos.has(m.equipmentNo));
        }
        return this.userMachineList;
      }
    },
    mounted() {
      this.getYesNo();
      this.getShuaKaQi();
      this.listMachineGroup();
      this.listFinance();
      this.getAgeDevice();
      this.getFeelLock();
      this.getAgeType();
      this.getPriorityMode();
      this.getIdcardCountry();
      this.loadKpis();
      const query = this.$route.query;
      if (query.equipmentNo) {
        this.search.equipmentNo = query.equipmentNo;
      }
      this.currentChange();
    },
    beforeDestroy() {
      mapMarker = null;
      mapPositions = [];
    },
    methods: {
      // ================= KPI =================
      loadKpis() {
        this.$api
          .request(this.$url.Consoles.getMachine, this.$method.get, {})
          .then(res => {
            if (res.code === 0) {
              this.kpi = res.data || {};
            }
          })
          .catch(() => {});
        this.$api
          .request(this.$url.Consoles.getAlarm, this.$method.get, {})
          .then(res => {
            if (res.code !== 0 || res.data === null || res.data === undefined) {
              return;
            }
            const d = res.data;
            let count = null;
            if (typeof d === "number") {
              count = d;
            } else if (Array.isArray(d)) {
              count = d.length;
            } else if (typeof d === "object") {
              count = [d.total, d.faultNum, d.count].find(v => typeof v === "number");
              count = count === undefined ? null : count;
            }
            if (count !== null && count !== undefined) {
              this.faultCount = count;
            }
          })
          .catch(() => {});
      },
      filterTotal() {
        this.mode = "list";
        this.onlineFilter = "all";
      },
      filterOnline() {
        this.mode = "list";
        this.onlineFilter = "online";
      },
      filterOffline() {
        this.mode = "list";
        this.onlineFilter = "offline";
      },
      filterFaults() {
        this.mode = "list";
        this.onlineFilter = "fault";
        this.loadFaultEquipmentNos();
      },
      // Faults KPI 没有对应的每台设备字段，按需拉取报警记录换算出设备号集合再过滤
      loadFaultEquipmentNos() {
        this.$api
          .request(this.$url.AlarmRecord.page, this.$method.get, { pageIndex: 1, pageSize: 100 })
          .then(res => {
            if (res.code === 0 && res.data) {
              const records = res.data.records || [];
              this.faultEquipmentNos = [...new Set(records.map(r => r.equipmentNo).filter(Boolean))];
            }
          })
          .catch(() => {});
      },
      handleModeChange(val) {
        if (val === "map") {
          this.$nextTick(() => this.ensureMap());
        } else if (val === "groups") {
          this.loadGroupsActive();
        }
      },
      // ================= 字典 =================
      listFinance() {
        this.$api.dict("gp_user_machine_mode").then(res => {
          this.modeList = res.data;
        });
      },
      getIdcardCountry() {
        this.$api.dict("sys_idcard_country").then(res => {
          if (res.code === 0) this.IdcardCountry = res.data;
        });
      },
      getYesNo() {
        this.$api.dict("sys_yes_no").then(res => {
          if (res.code === 0) this.yesNo = res.data;
        });
        this.$api.dict("gp_pay_type").then(res => {
          if (res.code === 0) this.payTypeList = res.data;
        });
        this.$api.dict("gp_pay_state").then(res => {
          if (res.code === 0) this.payStateList = res.data;
        });
      },
      getAgeDevice() {
        this.$api.dict("age_device").then(res => {
          if (res.code === 0) this.ageDevice = res.data;
        });
      },
      getFeelLock() {
        this.$api.dict("feel_lock").then(res => {
          if (res.code === 0) this.feelLock = res.data;
        });
      },
      getAgeType() {
        this.$api.dict("age_discern_type").then(res => {
          if (res.code === 0) this.ageType = res.data;
        });
      },
      getPriorityMode() {
        this.$api.dict("priority_mode").then(res => {
          if (res.code === 0) this.priorityMode = res.data;
        });
      },
      getShuaKaQi() {
        this.$api.dict("sys_shua_kaqi").then(res => {
          if (res.code === 0) this.shuaKaQi = res.data;
        });
      },
      listMachineGroup() {
        this.$api.request(this.$url.UserMachineGroup.list, this.$method.get).then(res => {
          if (res.code === 0) this.machineGroup = res.data;
        });
      },
      // ================= 列表 =================
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      currentChange(pageIndex) {
        let _self = this;
        _self.page.pageIndex = pageIndex ? pageIndex : 1;
        _self.loading = true;
        _self.loadError = false;
        let obj = _self.$cloud.objMerge(_self.search, _self.page);
        _self.$api
          .request(_self.$url.UserMachine.page, _self.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              _self.userMachineList = res.data.records || [];
              _self.page.totalSize = parseInt(res.data.total) || 0;
              _self.loadNotesForAllMachines();
              _self.loadInventorySummaries();
              _self.loadTxSummaries();
            }
            _self.loading = false;
          })
          .catch(() => {
            _self.loading = false;
            _self.loadError = true;
          });
      },
      refreshList() {
        this.showOpenDoorLine = false;
        this.currentChange(this.page.pageIndex);
      },
      async loadNotesForAllMachines() {
        const promises = this.userMachineList.map(async machine => {
          try {
            const response = await this.$api.request(this.$url.Notes.getByMachineNo, this.$method.get, {
              machineNo: machine.equipmentNo
            });
            const machineIndex = this.userMachineList.findIndex(m => m.equipmentNo === machine.equipmentNo);
            if (machineIndex === -1) return;
            if (response.code === 0 && response.data) {
              const newAddress = response.data.address || response.data.locale || response.data.location || "";
              this.$set(this.userMachineList, machineIndex, { ...this.userMachineList[machineIndex], locale: newAddress || null });
            } else {
              this.$set(this.userMachineList, machineIndex, { ...this.userMachineList[machineIndex], locale: null });
            }
          } catch (error) {
            const machineIndex = this.userMachineList.findIndex(m => m.equipmentNo === machine.equipmentNo);
            if (machineIndex !== -1) {
              this.$set(this.userMachineList, machineIndex, { ...this.userMachineList[machineIndex], locale: null });
            }
          }
        });
        await Promise.all(promises);
        this.$forceUpdate();
      },
      sortChange(column) {
        if (column.order === "ascending") {
          this.search.order = "asc";
          this.search.sort = column.prop;
        } else if (column.order === "descending") {
          this.search.order = "desc";
          this.search.sort = column.prop;
        } else {
          delete this.search.sort;
          delete this.search.order;
        }
        this.page.pageIndex = 1;
        this.currentChange();
      },
      onSubmit(data) {
        this.search = data;
        this.currentChange();
      },
      resetSearch(data) {
        this.search = data;
        this.onlineFilter = "all";
        this.currentChange();
      },
      onRowClick(row) {
        this.openMachineDrawer(row);
      },
      onlinePill(row) {
        if (row && row.mqState == 1) {
          return { cls: "vtm-pill--ok", label: this.$t("machineUser.onlinelabel1") };
        }
        if (row && row.mqState == 0) {
          return { cls: "vtm-pill--crit", label: this.$t("machineUser.onlinelabel2") };
        }
        return { cls: "vtm-pill--off", label: this.$t("machineUser.onlinelabel3") };
      },
      enableStatusLabel(row) {
        return this.$cloud.getDictLabel(this.yesNo, row && row.enableStatus);
      },
      exportUserMachine() {
        this.$confirm(this.$t("searchUserMachine.export"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            this.$api.download(this.$url.UserMachine.export, this.search);
          })
          .catch(err => {
            if (err && err.msg) this.$message.error(err.msg);
          });
      },
      cleanAddress(address) {
        if (!address) return address;
        const duplicatePattern = /^(.+?),\s*([^,]+),\s*\1,\s*(.+)$/;
        const match = address.match(duplicatePattern);
        const cleaned = match ? `${match[1]}, ${match[3]}` : address;
        return cleaned.replace(/,\s*USA\.?$/i, "");
      },
      // ================= 抽屉 =================
      openMachineDrawer(row) {
        this.drawerMachine = JSON.parse(JSON.stringify(row || {}));
        this.drawerTab = "overview";
        this.drawerVisible = true;
        this.machineOrders = [];
        this.prepareInlineSettings(row);
      },
      // 设备信息内联编辑：防抖自动保存（原「编辑设备」弹窗的 UserMachine.update 契约）
      queueMachineInfoSave() {
        if (this.infoSaveTimer) {
          clearTimeout(this.infoSaveTimer);
        }
        this.infoSaveTimer = setTimeout(() => {
          this.infoSaveTimer = null;
          this.saveMachineInfo();
        }, 800);
      },
      saveMachineInfo() {
        if (!this.drawerMachine || !this.drawerMachine.id) {
          return;
        }
        this.infoSaveState = "saving";
        const payload = JSON.parse(JSON.stringify(this.drawerMachine));
        this.$api
          .request(this.$url.UserMachine.update, this.$method.put, payload)
          .then(res => {
            if (res.code === 0) {
              this.infoSaveState = "saved";
              if (this.infoSaveResetTimer) clearTimeout(this.infoSaveResetTimer);
              this.infoSaveResetTimer = setTimeout(() => {
                this.infoSaveState = "idle";
              }, 2000);
              this.currentChange(this.page.pageIndex);
            } else {
              this.infoSaveState = "idle";
              this.$message.warning(res.msg || this.$t("common.loadFailed"));
            }
          })
          .catch(() => {
            this.infoSaveState = "idle";
          });
      },
      // 抽屉「交易」标签：懒加载该设备近期订单
      onDrawerTab(tab) {
        if (tab && tab.name === "transactions" && !this.machineOrders.length) {
          this.loadMachineOrders();
        }
      },
      loadMachineOrders() {
        if (!this.drawerMachine.equipmentNo) {
          return;
        }
        this.machineOrdersLoading = true;
        this.$api
          .request(this.$url.Order.page, this.$method.get, {
            equipmentNo: this.drawerMachine.equipmentNo,
            pageIndex: 1,
            pageSize: 15,
            sort: "buy_time",
            order: "desc"
          })
          .then(res => {
            this.machineOrdersLoading = false;
            if (res.code === 0 && res.data) {
              this.machineOrders = res.data.records || [];
            }
          })
          .catch(() => {
            this.machineOrdersLoading = false;
          });
      },
      // ---- 支付/退款（设备交易） ----
      money(v) {
        if (v === null || v === undefined || v === "") {
          return "$0.00";
        }
        const n = Number(v);
        return Number.isNaN(n) ? String(v) : `$${n.toFixed(2)}`;
      },
      payLabel(o) {
        return this.$cloud.getDictLabel(this.payTypeList, o.payType) || "-";
      },
      payStateText(o) {
        return this.$cloud.getDictLabel(this.payStateList, o.payState) || "-";
      },
      orderPillClass(o) {
        const s = Number(o.payState);
        return s === 1 ? "vtm-pill--ok" : s === 3 ? "vtm-pill--off" : "vtm-pill--warn";
      },
      cardLabelOf(o) {
        return orderCardLabel(o);
      },
      canRefund(o) {
        if (!o || !o.id) {
          return false;
        }
        const charged = Number(o.payablePrice) || 0;
        const refunded = Number(o.refundPrice) || 0;
        return charged > 0 && refunded < charged;
      },
      openRefund(o) {
        this.refundOrder = { ...o };
        this.refundVisible = true;
      },
      handleMachineRefundRefresh() {
        this.refundVisible = false;
        this.loadMachineOrders();
      },
      goMachineTxns() {
        this.drawerVisible = false;
        this.$router.push({ path: "/order/transaction-review", query: { equipmentNo: this.drawerMachine.equipmentNo } });
      },
      // 抽屉内联设置：打开时即填充配置与支付数据（无需再次点击进入弹窗）
      prepareInlineSettings(row) {
        this.ConfigSubmit = {
          ...emptyConfigSubmit(),
          config: JSON.parse(JSON.stringify(row.config || emptyConfigSubmit().config)),
          userEquipmentOpenDoorDTO: row.userEquipmentOpenDoorDTO
            ? JSON.parse(JSON.stringify(row.userEquipmentOpenDoorDTO))
            : {},
          equipmentNo: row.equipmentNo,
          id: row.id,
          verify: row.verify ? JSON.parse(JSON.stringify(row.verify)) : [],
          walletPrice: row.walletPrice
        };
        this.payment = {
          equipmentNo: row.equipmentNo,
          id: row.id,
          payConfig: row.payConfig ? JSON.parse(JSON.stringify(row.payConfig)) : {}
        };
      },
      // 逐台拉取近期订单，得出「最近交易时间 / 近7天销售额」（缓存；取最近100单，7天销售额为其中成功支付合计）
      loadTxSummaries() {
        const list = (this.userMachineList || []).slice(0, 40);
        const cutoff = Date.now() - 7 * 24 * 3600 * 1000;
        list.forEach(m => {
          if (!m.equipmentNo || this.txMap[m.id]) {
            return;
          }
          this.$api
            .request(this.$url.Order.page, this.$method.get, {
              equipmentNo: m.equipmentNo,
              pageIndex: 1,
              pageSize: 100,
              sort: "buy_time",
              order: "desc"
            })
            .then(res => {
              if (res.code !== 0 || !res.data) {
                return;
              }
              const records = Array.isArray(res.data.records) ? res.data.records : [];
              const lastTime = records.length ? records[0].createTime : "";
              let sales7d = 0;
              records.forEach(o => {
                const ts = new Date(String(o.createTime || "").replace(/-/g, "/")).getTime();
                if (!Number.isNaN(ts) && ts >= cutoff && Number(o.payState) === 1) {
                  sales7d += Number(o.payablePrice) || 0;
                }
              });
              this.$set(this.txMap, m.id, { lastTime, sales7d: Math.round(sales7d * 100) / 100 });
            })
            .catch(() => {});
        });
      },
      // 相对时间：与当前时间的差值（如 2h ago）
      relTime(t) {
        if (!t) {
          return "";
        }
        const then = new Date(String(t).replace(/-/g, "/")).getTime();
        if (Number.isNaN(then)) {
          return "";
        }
        const mins = Math.floor(Math.max(0, Date.now() - then) / 60000);
        if (mins < 1) return this.$t("dashboard.justNow");
        if (mins < 60) return this.$t("dashboard.minsAgo", { n: mins });
        const hrs = Math.floor(mins / 60);
        if (hrs < 24) return this.$t("dashboard.hrsAgo", { n: hrs });
        return this.$t("dashboard.daysAgo", { n: Math.floor(hrs / 24) });
      },
      // 逐台拉取货道配置，汇总「商品数 / 总库存」用于列表一览（缓存，避免重复请求）
      loadInventorySummaries() {
        const list = (this.userMachineList || []).slice(0, 40);
        list.forEach(m => {
          if (!m.id || this.invMap[m.id]) {
            return;
          }
          this.$api
            .request(this.$url.OpenDoor.getAisleGoodsConfig, this.$method.get, { userEquipmentId: m.id })
            .then(res => {
              if (res.code !== 0) {
                return;
              }
              const data = res.data || {};
              let items = [];
              if (Array.isArray(data)) {
                items = data;
              } else {
                Object.keys(data).forEach(k => {
                  if (Array.isArray(data[k])) {
                    items = items.concat(data[k]);
                  }
                });
              }
              const filled = items.filter(it => it && (it.goodsId || it.productId));
              const inventory = filled.reduce((sum, it) => {
                const v = it.currentInventoryLevel != null ? it.currentInventoryLevel : it.nowStock;
                return sum + (Number(v) || 0);
              }, 0);
              this.$set(this.invMap, m.id, { products: filled.length, inventory });
            })
            .catch(() => {});
        });
      },
      // ================= 复用弹窗 =================
      editUserMachine(row) {
        this.editEquipment = JSON.parse(JSON.stringify(row));
        this.editEquipment.id = row.id;
        this.dialogUserMachine = true;
      },
      editMachineCancel(dialog, state) {
        this.dialogUserMachine = dialog;
        if (state) this.currentChange(this.page.pageIndex);
      },
      // 内联设置保存回调（config-user-machine / payment inline 模式）
      configCancel(dialog, state) {
        if (state) this.currentChange(this.page.pageIndex);
      },
      cancelPayment(dialog, state) {
        if (state) this.currentChange(this.page.pageIndex);
      },
      openDoorLineProduct(row) {
        this.openDoorMachine = JSON.parse(JSON.stringify(row));
        this.openDoorMachine.id = row.id;
        this.showOpenDoorLine = true;
      },
      handlerCloseOpenDoorLine() {
        this.showOpenDoorLine = false;
      },
      openAdvertConfig(row) {
        this.advertConfigMachine = { equipmentNo: row.equipmentNo, equipmentName: row.equipmentName };
        this.dialogAdvertConfig = true;
      },
      handleAdvertConfigClose(dialog) {
        this.dialogAdvertConfig = dialog;
      },
      // ================= 二维码 =================
      showOpenDoorQr(row) {
        this.showOpenDoorQrCode = true;
        this.showOpenDoorQrLoading = true;
        this.openDoorQrCode = "";
        this.$api
          .request(this.$url.OpenDoor.getQrCodeConfig, this.$method.get, { userEquipmentId: row.id })
          .then(res => {
            if (res.code !== 0) {
              this.$message.warning(res.msg || "QR code failed");
              return;
            }
            const data = res.data || {};
            this.openDoorQrCode = data.qrCode || data.openDoorQrCode || data.url || data.imgUrl || "";
            if (!this.openDoorQrCode) this.$message.warning("No QR code found");
          })
          .finally(() => {
            this.showOpenDoorQrLoading = false;
          });
      },
      // ================= 设备控制（自 MachineMaps 移植） =================
      async handlerReStart(equipmentNo, type) {
        await this.$confirm(this.$t("machinesHub.confirmRestart"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        });
        this.$api
          .request(this.$url.UserMachine.reStartBoard, this.$method.post, { equipmentNo, type })
          .then(res => {
            this.$notify({ title: this.$t("common.tip"), message: res.msg, type: res.code === 0 ? "success" : "warning" });
          })
          .catch(() => {
            this.$notify({ title: this.$t("common.tip"), message: "reqest error", type: "warning" });
          });
      },
      handleOpenNetwork(item) {
        this.$api
          .request(this.$url.UserMachine.openNetWork, this.$method.post, { equipmentNo: item.equipmentNo })
          .then(res => {
            this.$notify({ title: this.$t("common.tip"), message: res.msg, type: res.code === 0 ? "success" : "warning" });
          })
          .catch(() => {
            this.$notify({ title: this.$t("common.tip"), message: "reqest error", type: "error" });
          });
      },
      handleCloseNetwork(item) {
        this.$api
          .request(this.$url.UserMachine.closeNetWork, this.$method.post, { equipmentNo: item.equipmentNo })
          .then(res => {
            this.$notify({ title: this.$t("common.tip"), message: res.msg, type: res.code === 0 ? "success" : "warning" });
          })
          .catch(() => {
            this.$notify({ title: this.$t("common.tip"), message: "reqest error", type: "error" });
          });
      },
      handleControl(item) {
        let _self = this;
        this.nowRemoteInfo = item;
        const loading = _self.$loading({
          lock: true,
          text: _self.$t("common.ljload"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        _self.$api
          .request(_self.$url.UserMachine.control, _self.$method.post, { equipmentNo: item.equipmentNo })
          .then(res => {
            if (res.code == 0) {
              _self.countError = 0;
              _self.getYCKZControl(item.equipmentNo, loading);
            } else {
              loading.close();
              _self.$notify({ title: _self.$t("common.tip"), message: res.msg, type: "warning" });
            }
          })
          .catch(() => {
            loading.close();
            _self.$notify({ title: _self.$t("common.tip"), message: "reqest error", type: "warning" });
          });
      },
      async delay(time) {
        return new Promise(resolve => setTimeout(resolve, time));
      },
      async getYCKZControl(equipmentNo, loading) {
        let _self = this;
        await this.delay(3000);
        this.countError++;
        if (this.countError > 20) {
          this.$message.warning(this.$t("user.MachineMaps.588934-10"));
          loading.close();
          if (!(this.nowRemoteInfo.remoteCode && this.nowRemoteInfo.remoteId && this.nowRemoteInfo.gotoHttpUrl)) {
            return;
          }
          this.control.remoteCode = this.nowRemoteInfo.remoteCode;
          this.control.remoteId = this.nowRemoteInfo.remoteId;
          this.control.url = this.nowRemoteInfo.gotoHttpUrl;
          let djs = setTimeout(function () {
            clearTimeout(djs);
            _self.$refs.btnForm.click();
          }, 1000);
          return;
        }
        _self.$api
          .request(_self.$url.UserMachine.getcontrol, _self.$method.get, { equipmentNo })
          .then(res => {
            if (res.code == 0) {
              if (res.data && res.data.remoteState == 2) {
                loading.close();
                _self.control.remoteCode = res.data.remoteCode;
                _self.control.remoteId = res.data.remoteId;
                _self.control.url = res.data.gotoHttpUrl;
                let djs = setTimeout(function () {
                  clearTimeout(djs);
                  _self.$refs.btnForm.click();
                }, 1000);
                return;
              } else if (res.data && res.data.remoteState == -1) {
                loading.close();
                _self.$notify({ title: _self.$t("common.tip"), message: _self.$t("common.ljfail"), type: "error" });
              } else {
                let djs = setTimeout(function () {
                  clearTimeout(djs);
                  _self.getYCKZControl(equipmentNo, loading);
                }, 1000);
              }
            } else {
              loading.close();
              _self.$notify({ title: _self.$t("common.tip"), message: res.msg, type: "warning" });
            }
          })
          .catch(res => {
            loading.close();
            _self.$notify({ title: _self.$t("common.tip"), message: JSON.stringify(res), type: "error" });
          });
      },
      // 直接开锁：不发短信/邮箱验证码（那一套按次收费，且对"开个门"这种日常操作来说是多余的摩擦），
      // 确认一次就调 OpenDoor.unlock 下发指令——这条路径要跟 doorcabinet App 的
      // post_opendoor 完全一致（同一台开门柜、同一个后端），不能用 UserMachine.electricLockDirect，
      // 那是弹簧货道机电子锁的接口，对开门柜没用（接口通但门不会真的开）
      handleUnlocking(item) {
        this.$confirm(this.$t("machinesHub.unlockConfirm"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            const loading = this.$loading({
              lock: true,
              text: this.$t("common.request"),
              spinner: "el-icon-loading",
              background: "rgba(0,0,0,0.7)"
            });
            this.$api
              .request(this.$url.OpenDoor.unlock, this.$method.post, { equipmentNo: item.equipmentNo })
              .then(res => {
                loading.close();
                this.$notify({
                  title: this.$t("common.tip"),
                  message: Number(res.code) === 0 ? this.$t("machinesHub.unlockSent") : res.msg || this.$t("machinesHub.commandFailed"),
                  type: Number(res.code) === 0 ? "success" : "warning"
                });
              })
              .catch(() => {
                loading.close();
                this.$notify({ title: this.$t("common.tip"), message: "request error", type: "warning" });
              });
          })
          .catch(() => {});
      },
      handleSendLogMQ(equipmentNo, type) {
        const loading = this.$loading({
          lock: true,
          text: this.$t("common.xiazload"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        this.$api
          .request(this.$url.UserMachine.sendMqtt, this.$method.post, { equipmentNo, type })
          .then(res => {
            if (res.code == 0) {
              this.actionQuery(equipmentNo, type, loading);
            } else {
              loading.close();
              this.$notify({ title: this.$t("common.tip"), message: res.msg, type: "warning" });
            }
          })
          .catch(() => {
            loading.close();
            this.$notify({ title: this.$t("common.tip"), message: "reqest error", type: "warning" });
          });
      },
      actionQuery(equipmentNo, type, loading) {
        let _self = this;
        _self.$api
          .request(_self.$url.UserMachine.androidlog, _self.$method.get, { equipmentNo, type })
          .then(res => {
            if (res.code == 0) {
              let records = res.data.records;
              loading.close();
              if (records.length > 0) {
                window.location.href = records[0]["url"];
              } else {
                _self.$notify({ title: _self.$t("common.tip"), message: _self.$t("common.xzcsl"), type: "warning" });
              }
            } else if (res.code == 1) {
              let djs = setTimeout(function () {
                clearTimeout(djs);
                _self.actionQuery(equipmentNo, type, loading);
              }, 3000);
            } else {
              loading.close();
              _self.$notify({ title: _self.$t("common.tip"), message: res.msg, type: "warning" });
            }
          })
          .catch(() => {
            loading.close();
            this.$notify({ title: this.$t("common.tip"), message: "reqest error", type: "warning" });
          });
      },
      // ================= 地址弹窗（自 MachineUser 移植） =================
      openAddressDialog(row) {
        this.selectedMachine = row;
        this.addressForm.location = row.locale || "";
        this.addressForm.machineNo = row.equipmentNo || "";
        this.getNotesByMachineNo(row.equipmentNo);
        this.addressDialogVisible = true;
      },
      getNotesByMachineNo(machineNumber) {
        return this.$api
          .request(this.$url.Notes.getByMachineNo, this.$method.get, { machineNo: machineNumber })
          .then(res => {
            if (res && res.code === 0 && res.data) {
              this.addressForm = {
                ...this.addressForm,
                machineNo: this.addressForm.machineNo,
                location: res.data.address || res.data.locale || this.addressForm.location,
                Contact: res.data.contactName || "",
                PhoneNumber: res.data.phoneNumber || "",
                email: res.data.email || "",
                Notes: res.data.notesContent || "",
                Installed: res.data.installDate || ""
              };
            }
            return Promise.resolve();
          })
          .catch(() => Promise.resolve());
      },
      querySearch(queryString, cb) {
        if (!queryString) {
          cb([]);
          return;
        }
        queryPlaces(queryString, { country: "us" }).then(results => cb(results));
      },
      handleAddressSelect(item) {
        this.addressForm.location = item.address;
        this.addressForm.lat = item.lat;
        this.addressForm.lng = item.lng;
      },
      clearAddress() {
        this.addressForm.location = "";
        this.addressForm.lat = null;
        this.addressForm.lng = null;
      },
      geocodeAddress(address) {
        return new Promise((resolve, reject) => {
          if (!address) {
            reject(new Error("No address provided"));
            return;
          }
          loadGoogle()
            .then(google => {
              const geocoder = new google.maps.Geocoder();
              geocoder.geocode({ address: address }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
                  const location = results[0].geometry.location;
                  resolve({ lat: location.lat(), lng: location.lng() });
                } else {
                  reject(new Error(`Geocoding failed: ${status}`));
                }
              });
            })
            .catch(error => reject(error));
        });
      },
      async saveAddress() {
        if (!this.addressForm.location) {
          this.$message.warning("Please enter an address");
          return;
        }
        let lat = (this.addressForm && this.addressForm.lat) || "";
        let lng = (this.addressForm && this.addressForm.lng) || "";
        if (!lat || !lng) {
          try {
            const coordinates = await this.geocodeAddress(this.addressForm.location);
            if (coordinates) {
              lat = coordinates.lat;
              lng = coordinates.lng;
            }
          } catch (error) {
            this.$message.warning("Could not get coordinates for the address. The address will be saved without map coordinates.");
          }
        }
        try {
          const machine = this.userMachineList.find(m => m.equipmentNo === this.addressForm.machineNo) || this.selectedMachine;
          if (!machine) {
            this.$message.error("Machine not found");
            return;
          }
          const machineUpdatePayload = {
            id: machine.id,
            teamId: machine.teamId,
            locale: this.addressForm.location,
            lat: lat,
            lng: lng
          };
          const notesUpdatePayload = {
            machineNo: this.addressForm.machineNo,
            machineId: machine.id,
            address: this.addressForm.location,
            lat: lat,
            lng: lng,
            contactName: this.addressForm.Contact || "N/A",
            phoneNumber: this.addressForm.PhoneNumber || "",
            email: this.addressForm.email || "",
            notesContent: this.addressForm.Notes || "",
            installDate: this.addressForm.Installed || ""
          };
          const [machineRes, notesRes] = await Promise.all([
            this.$api.request(this.$url.UserMachine.update, this.$method.put, machineUpdatePayload),
            this.$api.request(this.$url.Notes.updateByMachineNo, this.$method.put, notesUpdatePayload)
          ]);
          if (machineRes && machineRes.code === 0 && notesRes && notesRes.code === 0) {
            this.$message.success("Address updated successfully");
            this.addressDialogVisible = false;
            this.currentChange();
          } else {
            this.$message.error((machineRes && machineRes.msg) || (notesRes && notesRes.msg) || "Failed to update address");
          }
        } catch (error) {
          this.$message.error("Failed to update address");
        }
      },
      // ================= 地图（自 MachineMaps 移植） =================
      ensureMap() {
        if (this.mapInited) return;
        this.mapInited = true;
        this.initMap();
      },
      initMap() {
        let _self = this;
        _self.mapLoading = true;
        _self.$api
          .request(_self.$url.Map.data, _self.$method.get, { equipmentNo: "", equipmentName: "" })
          .then(res => {
            mapPositions = [];
            if (res.code === 0) {
              let totalpositions = res.data || [];
              for (let i = 0; i < totalpositions.length; i++) {
                if (totalpositions[i]["lat"] && totalpositions[i]["lng"]) {
                  mapPositions.push(totalpositions[i]);
                }
              }
              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                  function (position) {
                    _self.latitude = position.coords.latitude;
                    _self.longitude = position.coords.longitude;
                    _self.loadMaps(_self.latitude, _self.longitude);
                  },
                  function () {
                    let latitude = 22.977346659551902;
                    let longitude = 113.3884409976354;
                    _self.latitude = latitude;
                    _self.longitude = longitude;
                    _self.loadMaps(latitude, longitude);
                  }
                );
              } else {
                _self.loadMaps(22.977346659551902, 113.3884409976354);
              }
            } else {
              _self.mapLoading = false;
            }
          })
          .catch(() => {
            _self.mapLoading = false;
            _self.$notify({ title: this.$t("common.tip"), message: "reqest error", type: "warning" });
          });
      },
      loadMaps(latitude, longitude, zoom = 3) {
        let _self = this;
        let center = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
        loadGoogle()
          .then(google => {
            const mapOptions = {
              disableDefaultUI: true,
              center: center,
              zoom: zoom,
              gestureHandling: "greedy",
              mapTypeId: "terrain",
              fullscreenControl: true,
              fullscreenControlOptions: { position: google.maps.ControlPosition.LEFT_TOP },
              streetViewControl: true,
              streetViewControlOptions: { position: google.maps.ControlPosition.LEFT_TOP }
            };
            let map = new google.maps.Map(document.getElementById("hubMapBox"), mapOptions);
            if (parseInt(zoom) == 3) {
              mapMarker = new google.maps.Marker({
                map: map,
                position: center,
                animation: google.maps.Animation.DROP,
                icon: { url: "/img/position.png", scaledSize: new google.maps.Size(50, 50) },
                optimized: true
              });
            } else if (mapMarker) {
              mapMarker.setMap(null);
            }
            const markers = mapPositions.map(position => {
              const label = position.name;
              let contentString =
                '<div id="content"><div id="siteNotice"></div>' +
                '<h1 style="width: 100%; font-size: 18px; text-align: left; margin-bottom: 10px;">' +
                label +
                '</h1><div style="text-align: left;">' +
                '<div style="margin-bottom: 6px;"><strong>' +
                this.$t("user.nickName") +
                "：</strong><label>" +
                position.nickName +
                "</label></div>" +
                '<div style="margin-bottom: 6px;"><strong>' +
                this.$t("machine.equipmentNo") +
                "：</strong><label>" +
                position.equipmentNo +
                "</label></div>" +
                '<div style="margin-bottom: 6px;"><strong>' +
                this.$t("machine.position") +
                "：</strong><label>" +
                position.address +
                "</label></div>";
              if (position.online) {
                if (parseInt(position.online) == 0) {
                  contentString +=
                    '<div style="margin-bottom: 6px;"><strong>' +
                    this.$t("machineRecord.state") +
                    '：</strong><label style="color: #04F21C;">' +
                    this.$t("machineRecord.online") +
                    "</label></div>";
                } else if (parseInt(position.online) == 1) {
                  contentString +=
                    '<div style="margin-bottom: 6px;"><strong>' +
                    this.$t("machineRecord.state") +
                    '：</strong><label style="color: #d81e06;">' +
                    this.$t("machineRecord.unline") +
                    "</label></div>";
                }
              }
              contentString +=
                '<div style="margin-bottom: 6px;"><strong>' +
                this.$t("machineOrder.allPurchaseNum") +
                "：</strong><label>" +
                position.sales +
                "</label></div>" +
                '<div style="margin-bottom: 6px;"><strong>' +
                this.$t("machineOrder.allDuePrice") +
                "：</strong><label>$" +
                position.amount +
                "</label></div></div></div>";
              const infowindow = new google.maps.InfoWindow({ content: contentString, disableAutoPan: true });
              let newposition = { lat: parseFloat(position["lat"]), lng: parseFloat(position["lng"]) };
              let icon = "/img/undfine.png";
              if (position.online) {
                if (parseInt(position.online) == 1) {
                  icon = "/img/unline.png";
                } else if (parseInt(position.online) == 0) {
                  icon = "/img/online.png";
                }
              }
              const marker = new google.maps.Marker({
                position: newposition,
                animation: google.maps.Animation.DROP,
                icon: { url: icon, scaledSize: new google.maps.Size(50, 50) }
              });
              marker.addListener("click", () => {
                infowindow.open({ anchor: marker, map, shouldFocus: false });
                _self.openMapMachine(position);
              });
              return marker;
            });
            new MarkerClusterer({ map, markers });
            _self.mapLoading = false;
          })
          .catch(() => {
            _self.mapLoading = false;
          });
      },
      openMapMachine(position) {
        // 地图数据字段与列表不同：online 0=在线,1=离线；映射到 mqState 1/0
        let mqState = null;
        if (position.online !== undefined && position.online !== null && position.online !== "") {
          mqState = parseInt(position.online) === 0 ? 1 : 0;
        }
        this.openMachineDrawer({
          id: position.id || "",
          equipmentNo: position.equipmentNo,
          equipmentName: position.name || position.equipmentName || "",
          locale: position.address || "",
          servicePhone: position.servicePhone || "",
          mqState: mqState,
          enableStatus: position.enableStatus,
          userEquipmentTeam: {},
          verify: position.verify || [],
          remoteCode: position.remoteCode,
          remoteId: position.remoteId,
          gotoHttpUrl: position.gotoHttpUrl,
          lat: position.lat,
          lng: position.lng
        });
      },
      // ================= 分组 =================
      loadGroupsActive() {
        if (this.groupsTab === "groups" && !this.groupList.length) this.loadGroups();
        if (this.groupsTab === "labels" && !this.labelList.length) this.loadLabels();
        if (this.groupsTab === "transfer" && !this.transferList.length) this.loadTransfers();
      },
      handleGroupsTab(tab) {
        const name = tab.name;
        if (name === "groups") this.loadGroups();
        else if (name === "labels") this.loadLabels();
        else if (name === "transfer") this.loadTransfers();
      },
      // ---- 分组 CRUD ----
      loadGroups(pageIndex) {
        this.groupLoading = true;
        this.groupPage.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge({ userName: "", name: "" }, this.groupPage);
        this.$api
          .request(this.$url.UserMachineGroup.page, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.groupList = res.data.records || [];
              this.groupPage.totalSize = parseInt(res.data.total) || 0;
            }
            this.groupLoading = false;
          })
          .catch(() => {
            this.groupLoading = false;
          });
      },
      addUserMachineGroup() {
        this.userMachineGroup = { id: "", name: "", userEquipmentIds: [], maintenances: [] };
        this.dialogUserMachineGroup = true;
      },
      editMachineGroup(row) {
        const next = { id: "", name: "", userEquipmentIds: [], maintenances: [] };
        Object.keys(next).forEach(key => {
          if (row[key] !== undefined) next[key] = row[key];
        });
        next.id = row.id;
        this.userMachineGroup = next;
        this.dialogUserMachineGroup = true;
      },
      groupDialogCancel(dialog, state) {
        this.dialogUserMachineGroup = dialog;
        if (state) {
          this.loadGroups(this.groupPage.pageIndex);
          this.listMachineGroup();
        }
      },
      transferMachine(row) {
        this.moveTeamId = row.id;
        this.dialogMoveUserMachineGroup = true;
      },
      moveUserMachineGroupCancel(dialog) {
        this.dialogMoveUserMachineGroup = dialog;
      },
      openAdvertConfigGroup(row) {
        this.currentAdvertGroup = { id: row.id, name: row.name };
        this.dialogAdvertConfigGroup = true;
      },
      handleAdvertConfigGroupClose(dialog) {
        this.dialogAdvertConfigGroup = dialog;
      },
      delMachineGroup(row) {
        this.$confirm(this.$t("grouptransfer.delwarn"), this.$t("common.warning"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api.request(this.$url.UserMachineGroup.delete, this.$method.delete, { id: row.id }).then(res => {
            if (res.code === 0) {
              this.$notify({ title: this.$t("common.tip"), message: res.msg, type: "success" });
              this.loadGroups();
              this.listMachineGroup();
            }
          });
        });
      },
      // ---- 标签 CRUD ----
      loadLabels(pageIndex) {
        this.labelLoading = true;
        this.labelPage.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.labelSearch, this.labelPage);
        this.$api
          .request(this.$url.UserMachineLabels.page, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.labelList = res.data.records || [];
              this.labelPage.totalSize = parseInt(res.data.total) || 0;
            }
            this.labelLoading = false;
          })
          .catch(() => {
            this.labelLoading = false;
          });
      },
      addUserMachineLabel() {
        this.userMachineLabel = { id: "", name: "", userEquipmentId: [] };
        this.dialogUserMachineLabel = true;
      },
      editMachineLabel(row) {
        const next = { id: "", name: "", userEquipmentId: [] };
        Object.keys(next).forEach(key => {
          if (row[key] !== undefined) next[key] = row[key];
        });
        next.id = row.id;
        this.userMachineLabel = next;
        this.dialogUserMachineLabel = true;
      },
      labelDialogCancel(dialog, state) {
        this.dialogUserMachineLabel = dialog;
        if (state) this.loadLabels(this.labelPage.pageIndex);
      },
      delMachineLabel(row) {
        this.$confirm(this.$t("grouptransfer.delwarn"), this.$t("common.warning"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api.request(this.$url.UserMachineLabels.delete, this.$method.delete, { id: row.id }).then(res => {
            if (res.code === 0) {
              this.$notify({ title: this.$t("common.tip"), message: res.msg, type: "success" });
              this.loadLabels();
            }
          });
        });
      },
      // ---- 转移分组 CRUD ----
      loadTransfers(pageIndex) {
        this.transferLoading = true;
        this.transferPage.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.transferSearch, this.transferPage);
        this.$api
          .request(this.$url.UserMachineGroup.userMoveGroup, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.transferList = res.data.records || [];
              this.transferPage.totalSize = parseInt(res.data.total) || 0;
            }
            this.transferLoading = false;
          })
          .catch(() => {
            this.transferLoading = false;
          });
      },
      addUserGroupTransfer() {
        this.userGroupTransfer = { id: "", name: "", userMachineId: [] };
        this.dialogUserGroupTransfer = true;
      },
      editGroupTransfer(row) {
        const next = { id: "", name: "", userMachineId: [] };
        Object.keys(next).forEach(key => {
          if (row[key] !== undefined) next[key] = row[key];
        });
        next.id = row.id;
        delete next.userMachineId;
        this.userGroupTransfer = next;
        this.dialogUserGroupTransfer = true;
      },
      transferDialogCancel(dialog, state) {
        this.dialogUserGroupTransfer = dialog;
        this.userGroupTransfer = { id: "", name: "", userMachineId: [] };
        if (state) this.loadTransfers(this.transferPage.pageIndex);
      },
      handleDelGroupTransfer(row) {
        this.$confirm(this.$t("grouptransfer.delwarn"), this.$t("common.warning"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api.request(this.$url.Grouptransfer.delete, this.$method.delete, { id: row.id }).then(res => {
            if (res.code === 0) {
              this.$notify({ title: this.$t("common.tip"), message: res.msg, type: "success" });
              this.loadTransfers();
            }
          });
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  .machines-hub {
    padding-bottom: 24px;
  }

  /* KPI */
  .hub-kpis {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
    padding: 4px 16px 0;
  }

  .hub-kpi-click {
    cursor: pointer;
    transition: transform var(--vtm-speed) ease;

    &:hover {
      transform: translateY(-2px);
    }
  }

  /* 模式切换 */
  .hub-seg-row {
    padding: 10px 16px 0;
  }

  .hub-seg ::v-deep .el-radio-button__inner {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  /* 列表模式：模式切换并入工具条，右侧留出间距 */
  .hub-seg--inline {
    margin-right: 4px;
  }

  /* 设备交易列表 */
  .hub-txns__list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .hub-txn {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border: 1px solid var(--vtm-line);
    border-radius: var(--vtm-r-sm);
    background: var(--vtm-surface);
  }
  .hub-txn__main {
    flex: 1;
    min-width: 0;
  }
  .hub-txn__top {
    display: flex;
    align-items: center;
    gap: 8px;

    strong {
      font-family: var(--vtm-display);
      color: var(--vtm-heading);
    }
  }
  .hub-txn__sub {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-top: 3px;
    font-size: 12px;
    color: var(--vtm-ink-2);
  }
  .hub-txn__time {
    color: var(--vtm-ink-3);
    flex-shrink: 0;
  }
  .hub-txn__no {
    margin-top: 2px;
    font-family: var(--vtm-mono);
    font-size: 11px;
    color: var(--vtm-ink-3);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hub-txns__foot {
    display: flex;
    justify-content: center;
    padding-top: 8px;
  }

  /* 卡片/列表切换 */
  .hub-viewtoggle {
    display: inline-flex;
    border: 1px solid var(--vtm-line-2);
    border-radius: 6px;
    overflow: hidden;
    margin-left: 4px;

    button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 32px;
      border: none;
      background: var(--vtm-surface);
      color: var(--vtm-ink-3);
      cursor: pointer;
      font-size: 16px;

      & + button {
        border-left: 1px solid var(--vtm-line-2);
      }

      &:hover {
        color: var(--vtm-mint-ink);
      }

      &.is-active {
        background: var(--vtm-mint-soft);
        color: var(--vtm-mint-ink);
      }
    }
  }

  /* 列表单元格 */
  .hub-cell-machine {
    display: flex;
    flex-direction: column;
    line-height: 1.3;

    &__name {
      font-size: 13.5px;
      font-weight: 600;
      color: var(--vtm-ink);
    }

    &__no {
      font-size: 11.5px;
      font-family: var(--vtm-mono);
      color: var(--vtm-ink-3);
    }
  }

  /* 卡片视图 */
  .hub-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 14px;
    margin-top: 14px;
  }

  .hub-mcard {
    background: var(--vtm-surface);
    border: 1px solid var(--vtm-line);
    border-radius: var(--vtm-r-md);
    overflow: hidden;
    cursor: pointer;
    transition: box-shadow var(--vtm-speed) ease, border-color var(--vtm-speed) ease, transform var(--vtm-speed) ease;

    &:hover {
      border-color: var(--vtm-mint-dim);
      box-shadow: var(--vtm-e2);
      transform: translateY(-2px);
    }

    &__head {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 8px;
      padding: 12px 14px 8px;
    }

    &__title {
      display: flex;
      flex-direction: column;
      min-width: 0;
    }

    &__name {
      font-weight: 600;
      color: var(--vtm-ink);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &__no {
      font-size: 12px;
      color: var(--vtm-ink-3);
    }

    &__body {
      padding: 0 14px 12px;
    }

    &__row {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 12.5px;
      color: var(--vtm-ink-2);
      margin-top: 6px;

      i {
        color: var(--vtm-ink-3);
      }
    }
  }

  /* 地图 */
  .hub-map-wrap {
    position: relative;
    margin: 14px 16px 0;
    height: 640px;
    background: var(--vtm-surface);
    border: 1px solid var(--vtm-line);
    border-radius: var(--vtm-r-md);
    overflow: hidden;
  }

  .hub-map-box {
    width: 100%;
    height: 100%;
    text-align: center;
  }

  /* 分组 */
  .hub-groups {
    padding: 14px 16px 0;
  }

  .hub-groups__toolbar {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 10px;
  }

  .hub-groups ::v-deep .el-pagination {
    margin-top: 12px;
    text-align: right;
  }

  /* 抽屉 */
  .hub-detail {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .hub-detail__topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 20px;
    border-bottom: 1px solid var(--vtm-line);
  }

  .hub-detail__title {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    min-width: 0;

    i {
      font-size: 22px;
      color: var(--vtm-mint-ink);
    }
  }

  .hub-detail__name {
    font-family: var(--vtm-display);
    font-size: 16px;
    font-weight: 650;
    color: var(--vtm-heading);
  }

  .hub-detail__no {
    font-size: 12px;
    color: var(--vtm-ink-3);
  }

  .hub-detail__pills {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .hub-detail__scroll {
    flex: 1;
    overflow-y: auto;
    padding: 8px 20px 18px;
  }

  .hub-detail__kv {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px 16px;
    padding: 14px 16px;
    margin: 8px 0 14px;
    border: 1px solid var(--vtm-line);
    border-radius: var(--vtm-r-md);
    background: var(--vtm-surface-2);
  }

  .hub-detail__kv-item {
    min-width: 0;

    &--full {
      grid-column: 1 / -1;
    }
  }

  .hub-detail__kv-label {
    display: block;
    font-size: 11.5px;
    color: var(--vtm-ink-3);
    margin-bottom: 3px;
  }

  /* 出厂默认机名：字段级提醒 */
  .hub-detail__input--warn ::v-deep .el-input__inner {
    border-color: var(--vtm-warn);
    background: var(--vtm-warn-soft);
  }
  .hub-detail__field-warn {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.45;
    color: var(--vtm-warn);

    i {
      margin-right: 3px;
    }
  }

  .hub-detail__kv-value {
    font-size: 13px;
    font-weight: 600;
    color: var(--vtm-ink);
    word-break: break-word;
  }

  /* 主操作区：两列等宽网格，避免换行错位（覆盖 Element 相邻按钮的 margin-left） */
  .hub-detail__actions-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;

    ::v-deep .el-button {
      width: 100%;
      margin-left: 0;
    }
  }

  .hub-cell-lasttx {
    display: flex;
    flex-direction: column;
    line-height: 1.3;

    &__time {
      font-size: 12.5px;
      color: var(--vtm-ink);
      font-variant-numeric: tabular-nums;
    }
    &__ago {
      font-size: 11px;
      color: var(--vtm-ink-3);
    }
  }

  .hub-detail__kv-savehint {
    display: flex;
    justify-content: flex-end;
    font-size: 12px;

    .is-hint {
      color: var(--vtm-ink-3);
    }
    .is-saving {
      color: var(--vtm-info);
    }
    .is-saved {
      color: var(--vtm-ok);
      font-weight: 600;
    }
  }

  .hub-detail__actions-col {
    display: flex;
    flex-direction: column;
    gap: 10px;

    ::v-deep .el-dropdown {
      width: 100%;
    }
  }

  .hub-detail__section-hint {
    font-size: 12.5px;
    color: var(--vtm-ink-3);
    margin: 4px 0 12px;
  }

  .hub-detail__ctrlhint {
    margin-bottom: 14px;
  }

  .hub-detail__footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 12px 20px;
    border-top: 1px solid var(--vtm-line);
  }

  /* 地址弹窗（沿用 MachineUser 样式） */
  .dialog-title-left {
    display: block;
    text-align: left;
    font-size: 22px;
    font-weight: 600;
    color: var(--vtm-heading);
    padding-left: 4px;
  }

  .address-suggestion-item {
    display: flex;
    align-items: flex-start;
    padding: 6px 10px;
  }

  .location-icon-bg {
    flex: 0 0 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--vtm-well);
    border-radius: 50%;
    margin-right: 10px;

    i {
      font-size: 18px;
      color: var(--vtm-mint-ink);
    }
  }

  .suggestion-text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }

  .suggestion-title {
    font-weight: 600;
    font-size: 14px;
    color: var(--vtm-ink);
    margin-bottom: 2px;
  }

  .suggestion-address {
    font-size: 12px;
    color: var(--vtm-ink-3);
  }

  .ip-icon {
    margin-top: 13px;
  }

  @media (max-width: 900px) {
    .hub-kpis {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .hub-detail__kv {
      grid-template-columns: 1fr;
    }
  }

  /* 库存一览（列表/卡片） */
  .hub-inv-pending {
    color: var(--vtm-ink-3);
  }

  .hub-mcard__inv {
    display: flex;
    gap: 18px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid var(--vtm-line);
  }
  .hub-mcard__inv-item {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
  }
  .hub-mcard__inv-val {
    font-family: var(--vtm-display);
    font-weight: 700;
    font-size: 16px;
    color: var(--vtm-heading);
  }
  .hub-mcard__inv-label {
    font-size: 11px;
    color: var(--vtm-ink-3);
  }
  .hub-mcard__foot {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid var(--vtm-line);
    display: flex;
    justify-content: flex-end;
  }

  /* 抽屉内联设置 */
  .hub-settings {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }
  .hub-settings__block {
    background: var(--vtm-surface);
  }
  .hub-detail__subtitle {
    font-family: var(--vtm-display);
    font-size: 13px;
    font-weight: 600;
    color: var(--vtm-heading);
    margin-bottom: 10px;
    padding-bottom: 6px;
    border-bottom: 1px solid var(--vtm-line);
  }
</style>
